import { AssistantAnswer, AssistantMode, QaSource } from '../types';

interface RagShape {
    question: string;
    answer: string;
    sources?: QaSource[];
    retrieved_count?: number;
    prompt_version: string;
    provider: string;
    model: string;
}

interface SqlShape {
    question: string;
    answer: string;
    sql?: string | null;
    columns?: string[];
    rows?: unknown[][];
    row_count?: number;
    truncated?: boolean;
    prompt_version: string;
    provider: string;
    model: string;
}

export function buildRagAnswer(response: RagShape, id: string): AssistantAnswer {
    return {
        id,
        question: response.question,
        mode: AssistantMode.RAG,
        answer: response.answer,
        timestamp: new Date().toISOString(),
        sources: response.sources ?? [],
        meta: {
            retrievedCount: response.retrieved_count,
            promptVersion: response.prompt_version,
            provider: response.provider,
            model: response.model,
        },
    };
}

export function buildSqlAnswer(response: SqlShape, id: string): AssistantAnswer {
    return {
        id,
        question: response.question,
        mode: AssistantMode.SQL,
        answer: response.answer,
        timestamp: new Date().toISOString(),
        sqlResult: response.sql
            ? {
                  sql: response.sql,
                  columns: response.columns ?? [],
                  rows: response.rows ?? [],
                  rowCount: response.row_count ?? 0,
                  truncated: Boolean(response.truncated),
              }
            : undefined,
        meta: {
            promptVersion: response.prompt_version,
            provider: response.provider,
            model: response.model,
        },
    };
}
